import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HijoResumen } from './hijos.state';

export const HijosActions = createActionGroup({
  source: 'Hijos',
  events: {
    'Load Hijos': emptyProps(),
    'Load Hijos Success': props<{ hijos: HijoResumen[] }>(),
    'Load Hijos Failure': props<{ error: string }>(),
  },
});
